module.exports = __webpack_public_path__ + "media/images/mobile/logo/menu-icon-3616f476bc4151a7af56d80ded49b054.png";